import {
	Component, Input, OnInit, OnChanges, SimpleChanges, OnDestroy} from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { MonitorConfigComponentBase } from '../MonitorConfigComponentBase';
import { MonitorPolicy } from 'DiscoveryEngine.TS/Monitors';
import { Schedule, ScheduleType } from 'DiscoveryEngine.TS/Utils';


@Component({
	selector: 'monitor-history',
	templateUrl: './monitorhistory.component.html',
	styleUrls: ['./monitorhistory.component.scss']
})
export class MonitorHistoryComponent extends MonitorConfigComponentBase implements OnInit, OnChanges, OnDestroy {

	@Input()
	public schedule: Schedule;

	public keepCount: UntypedFormControl;

	constructor(private fb: UntypedFormBuilder) {
		super();
	}

	public ngOnInit(): void {
		this.BuildForm();
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes["editor"]) {
			this.BuildForm();
		}
	}

	public ngOnDestroy(): void {

	}

	public BuildForm(): void {
		let keepCount = 1;

		if (!!this.editor && this.editor.HasPolicy) {

			let monPolicy: MonitorPolicy = this.editor.Policy;

			keepCount = monPolicy.Settings.LimitCount;
		}

		this.keepCount = new UntypedFormControl(keepCount, Validators.compose([Validators.required, this.minValue(1), this.maxValue(1000)]));

		this.SettingsForm = this.fb.group({
			keepCount: this.keepCount,
		});
	}

	public applyTempChanges(): void {
		if (!!this.editor && this.editor.HasPolicy) {

			let monPolicy: MonitorPolicy = this.editor.Policy;

			monPolicy.Settings.LimitCount = this.keepCount.value;

			this.BuildForm();
		}
	}

	public get invalidTempChanges(): string[] {
		return ["History"];
	}

	public get storageEstimate(): string {
		let value = "";

		if (!!this.schedule && !!this.keepCount) {
			value = this._getStorageEstimate(this.schedule, this.keepCount.value);
		}

		return value;
	}

	private _getStorageEstimate(schedule: Schedule, count: number): string {
		let label = "";

		let months = 0, weeks = 0, days = 0, hours = 0, minutes = 0;

		switch (schedule.Type) {
			case ScheduleType.Minutes_Interval:
				minutes = schedule.OneInterval * count;
				break;
			case ScheduleType.Hours_Interval:
				minutes = schedule.OneInterval * count * 60;
				break;
			case ScheduleType.Days_Interval:
				minutes = schedule.OneInterval * count * 24 * 60;
				break;
			case ScheduleType.Weekly_SelectedDays:
				weeks = count / schedule.DaysOfWeek.Count;
				break;
			case ScheduleType.Monthly_NthDay:
			case ScheduleType.Monthly_OrdinalDay:
				months = count;
				break;
		}

		if (minutes > 0) {
			weeks += minutes / 10080;
			minutes = minutes % 10080;
			days = minutes / 1440;
			minutes = minutes % 1440;
			hours = minutes / 60;
			minutes = minutes % 60;
		}

		if (months > 0) {
			label = `${months} Month(s)`;
		}
		else if (weeks >= 1) {
			if (weeks == Math.floor(weeks))
				label = `${weeks} Week(s)`;
			else
				label = `${weeks.toFixed(1)} Week(s)`;
		}
		else if (days >= 1) {
			if (days == Math.floor(days))
				label = `${days} Day(s)`;
			else
				label = `${days.toFixed(1)} Day(s)`;
		}
		else if (hours >= 1) {
			if (hours == Math.floor(hours))
				label = `${hours} Hour(s)`;
			else
				label = `${hours.toFixed(1)} Hour(s)`;
		}
		else if (minutes >= 0) {
			label = `${minutes} Minute(s)`;
		}

		return label;
	}

}
